<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <WhyCodepressoContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import WhyCodepressoContent from "~~/codepresso-renewal/content/WhyCodepressoContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "코드프레소 차별점 — 도구도 교육도, 그리고 연결까지 | 코드프레소",
  meta: [
    { name: "description", content: "도구 전문 회사는 사람을 못 바꾸고, 교육 회사는 도구가 없습니다. Codepresso는 둘 다, 그리고 연결까지 합니다." },
    { name: "title", content: "코드프레소 차별점 — 도구도 교육도, 그리고 연결까지 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "코드프레소 차별점 — 도구도 교육도, 그리고 연결까지 | 코드프레소" },
    { property: "og:description", content: "도구 전문 회사는 사람을 못 바꾸고, 교육 회사는 도구가 없습니다. Codepresso는 둘 다, 그리고 연결까지 합니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/why-codepresso.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
